import {
  Box,
  ButtonToggleSwitcher,
  InputAutoComplete,
  Typography,
} from '@capitalise/ui-design-system';
import { ISelectedCompany } from '.';
import CompanySearch from 'RemoteBusiness/CompanySearch';
import { UserType } from 'enums/user-type';

export interface IDownloadScreenProps {
  selectedCompany: ISelectedCompany;
  setSelectedCompany: Function;
  isLoading: boolean;
  isOpen: boolean;
  setIsOpen: Function;
  companies: any[];
  setQuery: Function;
  setValue: Function;
}

const DownloadScreen = ({
  selectedCompany,
  setSelectedCompany,
  isLoading,
  setValue,
}: IDownloadScreenProps) => {
  const analyticParams = {
    userType: UserType.introducer,
    origin: 'PDF_download',
  };

  return (
    <>
      <Typography size="heading-28" color="grey-900">
        Download a capital report
      </Typography>
      <Typography size="body-16" color="grey-700" pt="3xsmall">
        A report can be created using Companies House, cloud accounting and Open Banking
      </Typography>
      <Box width="100%" pt="large">
        <CompanySearch
          onChange={(value) => {
            setValue('name', value.companyName);
            setSelectedCompany({ label: value.companyName, number: value.registrationNumber });
          }}
          onClear={() => {
            setValue('name', null);
            setSelectedCompany(null);
          }}
          inputProps={{
            label: 'Company name or number',
            showLabel: true,
          }}
          analyticParams={analyticParams}
          initAnalytics
        />
        {selectedCompany && (
          <Box pt="large" display="flex" alignItems="center">
            <ButtonToggleSwitcher
              disabled={isLoading}
              aria-label="switchAddCompany"
              onChange={(value) => setValue('addCompany', value)}
            />
            <Typography size="body-14" color="grey-500" pl="4xsmall">
              Add company to Monitor
            </Typography>
          </Box>
        )}
      </Box>
    </>
  );
};

export default DownloadScreen;
